module.exports = __webpack_public_path__ + "static/media/google.196140c2.svg";